
import { useState } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { MobileNavTabs } from "./MobileNavTabs";
import { MobileNavigation } from "./MobileNavigation";
import { MobileSearchBox } from "./MobileSearchBox";
import { MobileUserSection } from "./MobileUserSection";
import { MobileSecondaryNav } from "./MobileSecondaryNav";
import { MobileFooterAction } from "./MobileFooterAction";
import { useUserStore } from "@/store/userStore";

interface MobileSidebarContentProps {
  activeCategory: string;
  setActiveCategory: (category: string) => void;
  categories: Record<string, any[]>;
  secondaryNavigation: any[];
}

export const MobileSidebarContent = ({
  activeCategory,
  setActiveCategory,
  categories,
  secondaryNavigation
}: MobileSidebarContentProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const {user} = useUserStore()
  
  // Filter navigation items by search query
  const filteredItems = categories[activeCategory]?.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
  (!item.roles || item.roles.includes(user?.role))
  ) || [];

  return (
    <div className="flex flex-col h-full">
      {/* Logo and Header */}
      <div className="p-4 border-b">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-r from-emerald-500 to-sky-500 flex items-center justify-center shadow-md rotate-3">
            <span className="text-white font-bold text-lg">D</span>
          </div>
          <span className="text-lg font-bold bg-gradient-to-r from-emerald-600 to-sky-600 bg-clip-text text-transparent">
            DGK Hub
          </span>
        </Link>
      </div>
      
      {/* User Section */}
      <MobileUserSection />
      
      {/* Search Box */}
      <MobileSearchBox 
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      
      {/* Navigation Tabs */}
      <MobileNavTabs 
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />
      
      {/* Navigation Items */}
      <div className="flex-1 overflow-y-auto custom-scrollbar p-3">
        <MobileNavigation items={filteredItems} />
      </div>
      
      {/* Secondary Navigation */}
      {/* <MobileSecondaryNav items={secondaryNavigation} /> */}
      
      {/* Footer Action */}
      <MobileFooterAction />
    </div>
  );
};
